/**
 * 面向业务通用方法
 * 包括获取活动配置、埋点上报、分享，需要mku原生支持
 */

import fetchData from "./fetchData";
import {
  nShare,
  callHybridHandle,
  generateRandomString,
  appInfo,
  openWebView,
} from "@eastmoney/mku";
import pinia from "@/pinia/pinia";
import { useMainStore } from "@/pinia/main";
const userStore = useMainStore(pinia);
const { setUserInfo, shareTaskItem, haslogin, shareid } = userStore;

declare global {
  interface Window {
    sendTrackLog: (
      ElementType: string,
      EventType?: string,
      EventCode?: string,
      ExtInfo?: string,
      goToUrl?: string,
    ) => void;
  }
}
/**
 * 埋点上报
 */
const sendTrackMed = (EventCode: string) => {
  console.log("上报埋点", EventCode);
  window.sendTrackLog("button", "click", EventCode, "", "");
};
/**
 * 版本比较
 * v1 当前的版本
 * v2 需要对比的版本
 * 0 相同
 * 1 大于
 * -1 小于
 */
const compareVersions = (v2: string): number => {
  let v1 = window.clientVersion;
  v1 = v1 + "";
  v2 = v2 + "";
  const parts1 = v1.split(".").map(Number);
  const parts2 = v2.split(".").map(Number);

  for (let i = 0; i < Math.max(parts1.length, parts2.length); i++) {
    const num1 = parts1[i] || 0;
    const num2 = parts2[i] || 0;

    if (num1 > num2) return 1;
    if (num1 < num2) return -1;
  }

  return 0;
};
let configData: any = null;

/**
 * 获取配置
 */
const getActConfigInfo = (callback: any) => {
  const obj = {
    api: "/api/config",
    success: (res: any) => {
      if (res && res["data"]) {
        configData = res["data"];
        setUserInfo({
          configObj: configData,
        });
        if (callback) {
          callback(configData);
        }
      } else {
        if (callback) {
          callback();
        }
      }
    },
  };
  fetchData.doGet(obj);
};
/**
 * 资讯发布时间格式化
 * @param n 数字
 * @returns 格式化后的数字
 */
const formatNumber = (n: any) => {
  n = n.toString();
  return n[1] ? n : "0" + n;
};
const pubTime = (ftime: any) => {
  if (typeof ftime === "string") {
    ftime = ftime.replace(/-/g, "/");
  }
  ftime = new Date(ftime);
  let nowtime = new Date().getTime();
  let offset = nowtime - ftime.getTime();
  let ayear = ftime.getFullYear(),
    amonth = ftime.getMonth() + 1,
    aday = ftime.getDate(),
    ahour = ftime.getHours(),
    aminutes = ftime.getMinutes();
  if (offset >= 24 * 60 * 60 * 1000) {
    if (ayear < new Date().getFullYear()) {
      return (
        [ayear, formatNumber(amonth), formatNumber(aday)].join("-") +
        " " +
        [formatNumber(ahour), formatNumber(aminutes)].join(":")
      );
    } else {
      return (
        [formatNumber(amonth), formatNumber(aday)].join("-") +
        " " +
        [formatNumber(ahour), formatNumber(aminutes)].join(":")
      );
    }
  } else if (offset >= 1 * 60 * 60 * 1000) {
    return parseInt((offset / 1000 / 60 / 60).toString()) + "小时前";
  } else if (offset >= 1 * 60 * 1000) {
    return parseInt((offset / 1000 / 60).toString()) + "分钟前";
  } else {
    return "刚刚";
  }
};

/**
 * 获取取cookie
 * @param c_name
 * @returns
 */
const getCookie = (c_name: string) => {
  let c_start: any;
  let c_end: any;
  if (document.cookie.length > 0) {
    c_start = document.cookie.indexOf(c_name + "=");
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1;
      c_end = document.cookie.indexOf(";", c_start);
      if (c_end == -1) c_end = document.cookie.length;
      return decodeURIComponent(document.cookie.substring(c_start, c_end));
    }
  }
  return "";
};

/**
 * 复制内容到剪切板
 */
const copyContent = (obj: any) => {
  callHybridHandle({
    moduleName: "Compat", // 模块
    methodName: "emH5ClipBoard", // 方法名
    requestJson: {
      content: obj && obj['content']
    },
    callback: (res: any) => {
      console.log(res, "----emH5ClipBoard");
      if (res && res['data']) {
        if (res['data'] && res['data'].isSuccess) {
          obj && obj.callback && obj.callback(true)
        } else {
          obj && obj.callback && obj.callback(false)
        }
      } else {
        obj && obj.callback && obj.callback(false)
      }

    },
  });
}

export { getCookie, copyContent, sendTrackMed, compareVersions, getActConfigInfo, pubTime };
